import type { Config } from '@packages/config/src/default/types';
import { logger } from '../logger/logger';
import { isValidDate } from './isValidDate';

// Intl.DateTimeFormat construction is the expensive part; one formatter per time zone is
// enough because they are stateless.
const formatters = new Map<string, Intl.DateTimeFormat>();

const getFormatter = (timeZone: string) => {
  let formatter = formatters.get(timeZone);
  if (!formatter) {
    // en-CA formats as YYYY-MM-DD
    formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
    formatters.set(timeZone, formatter);
  }
  return formatter;
};

/**
 * The calendar day of the given instant in the given time zone, as `YYYY-MM-DD`.
 * Day strings of this shape compare correctly with `<` and `>`.
 * @param timeZone The desired time zone (e.g. "Europe/Amsterdam")
 */
export const toLocalDay = (date: Date, timeZone: Config['timeZone'] = 'Europe/Berlin') => {
  if (!isValidDate(date)) {
    logger.warn({ date }, 'toLocalDay received an invalid date');
    return null;
  }

  return getFormatter(timeZone).format(date);
};
